import styled from '../../../../../theme'

const ButtonLabel = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: white;
`
export default ButtonLabel
